export const OLD_CHECKOUT = 'oldCheckout';
